import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledSvg = styled.svg`
  position: absolute;
  width: 73%;
  height: auto;
  bottom: 54%;
  left: 2%;

  .cls-1 {
    fill: #fff;
  }

  .cls-2 {
    fill: ${({ $fill }) => $fill};
  }
`;

const Eyes = ({ fill }) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width="236.968"
      height="118.769"
      viewBox="0 0 236.968 118.769"
      $fill={fill}
    >
      <g
        id="eye_woman_4"
        data-name="eye woman 4"
        transform="translate(-218.822 -277.823)"
      >
        <g id="Group_403" data-name="Group 403">
          <g id="Group_393" data-name="Group 393">
            <g id="Group_386" data-name="Group 386">
              <g id="Group_385" data-name="Group 385">
                <path
                  id="Path_422"
                  data-name="Path 422"
                  d="M451.542,319.359c.131.069.205.227.211.494a2.444,2.444,0,0,1-.257,1.094,6.82,6.82,0,0,1-2.936,2.938,12.314,12.314,0,0,1-6.4,1.463,16.6,16.6,0,0,1-8.268-2.732,11.827,11.827,0,0,1-1-.7l-.649-.5a3.724,3.724,0,0,1-.693-.6c-.77-1.268-1-1.6-1.434-2.229-.8-1.168-1.636-2.356-2.561-3.516a42.321,42.321,0,0,0-6.469-6.668A40.72,40.72,0,0,0,412.5,303a36.73,36.73,0,0,0-4.916-1.849,38.147,38.147,0,0,0-16.163-1c-.877.1-1.727.3-2.582.448-.838.215-1.687.367-2.5.623a29.462,29.462,0,0,0-4.607,1.642,34.332,34.332,0,0,0-7.726,4.853,63.352,63.352,0,0,0-6.105,5.748c-1.8,1.889-3.332,3.723-4.68,5.35l-3.438,4.249c-1.911,2.353-3.075,3.644-3.575,3.418s-.294-2.017.76-4.986a43.891,43.891,0,0,1,2.288-5.256,56.968,56.968,0,0,1,3.919-6.562,50.212,50.212,0,0,1,6.02-7.273,37.5,37.5,0,0,1,9.024-6.737,34.517,34.517,0,0,1,5.671-2.4c.975-.355,1.993-.6,3.009-.894,1.031-.226,2.065-.507,3.131-.669a42.93,42.93,0,0,1,20.037,1.049,41.607,41.607,0,0,1,6.214,2.471,43.962,43.962,0,0,1,10.2,7.036,43.374,43.374,0,0,1,7.113,8.549c.935,1.447,1.736,2.885,2.453,4.273a11.05,11.05,0,0,1,.738,1.561.465.465,0,0,0,.077.119.961.961,0,0,0,.155.175,7.4,7.4,0,0,0,.617.591,13.048,13.048,0,0,0,5.152,2.859,11.159,11.159,0,0,0,4.513.25,10.309,10.309,0,0,0,2.855-.895c.361-.135.61-.279.84-.356A.721.721,0,0,1,451.542,319.359Z"
                />
              </g>
            </g>
            <g id="Group_388" data-name="Group 388">
              <g id="Group_387" data-name="Group 387">
                <path
                  id="Path_423"
                  data-name="Path 423"
                  d="M299.09,333.918c-.278.093-.683-.172-1.207-.737s-1.114-1.453-1.915-2.554c-.752-1.12-1.694-2.462-2.795-3.981-.564-.753-1.133-1.57-1.809-2.387l-1.007-1.274-1.107-1.3A56.431,56.431,0,0,0,284,316.321a33.23,33.23,0,0,0-6.651-4.7,13.675,13.675,0,0,0-3.449-1.211l-2.337-.311c-.789-.088-1.586-.132-2.388-.207a38.273,38.273,0,0,0-9.744.571,32.718,32.718,0,0,0-9.058,3.127,35.6,35.6,0,0,0-7.4,5.2,40.521,40.521,0,0,0-5.566,6.235,36.226,36.226,0,0,0-2.055,3.156l-.4.736-.166.323-.069.136-.107.236q-.442.971-.868,1.9c-.322.616-.675,1.213-1,1.788-.346.575-.777,1.128-1.151,1.655-.412.526-.9,1.018-1.335,1.484a12.219,12.219,0,0,1-1.6,1.221A7.436,7.436,0,0,1,225,338.808a6.9,6.9,0,0,1-5.776-3.128c-.431-.706-.492-1.188-.3-1.379.2-.207.652-.118,1.352.08a11.669,11.669,0,0,0,2.713.621,3.773,3.773,0,0,0,1.516-.2,3.894,3.894,0,0,0,1.3-.966,12.4,12.4,0,0,0,2.336-4.658l.458-1.633.161-.537.2-.588c.131-.379.267-.726.41-1.082a35.8,35.8,0,0,1,2.024-4.139,41.077,41.077,0,0,1,6.017-8.078,39.15,39.15,0,0,1,8.9-6.96,37.811,37.811,0,0,1,11.472-4.215,42.013,42.013,0,0,1,12.053-.569c.955.112,1.908.2,2.838.342l2.756.487a20.363,20.363,0,0,1,5.83,2.361,35.488,35.488,0,0,1,7.871,6.6,46.279,46.279,0,0,1,5.147,6.871q.5.838.974,1.636c.3.539.57,1.08.84,1.6.553,1.027.98,2.046,1.383,2.989a30.77,30.77,0,0,1,1.635,5,13.3,13.3,0,0,1,.429,3.324C299.51,333.376,299.368,333.825,299.09,333.918Z"
                />
              </g>
            </g>
            <g id="Group_389" data-name="Group 389">
              <ellipse
                id="Ellipse_55"
                data-name="Ellipse 55"
                className="cls-1"
                cx="42.677"
                cy="44.053"
                rx="42.677"
                ry="44.053"
                transform="translate(354.203 299.646)"
              />
            </g>
            <g id="Group_390" data-name="Group 390">
              <ellipse
                id="Ellipse_56"
                data-name="Ellipse 56"
                className="cls-2"
                cx="29.424"
                cy="29.869"
                rx="29.424"
                ry="29.869"
                transform="translate(379.006 312.372)"
              />
              <path
                id="Path_424"
                data-name="Path 424"
                d="M408.43,373.109a30.871,30.871,0,1,1,30.424-30.868A30.683,30.683,0,0,1,408.43,373.109Zm0-59.736a28.871,28.871,0,1,0,28.424,28.868A28.681,28.681,0,0,0,408.43,313.373Z"
              />
            </g>
            <g id="Group_391" data-name="Group 391">
              <ellipse
                id="Ellipse_57"
                data-name="Ellipse 57"
                className="cls-1"
                cx="36.188"
                cy="41.524"
                rx="36.188"
                ry="41.524"
                transform="translate(229.216 308.4)"
              />
            </g>
            <g id="Group_392" data-name="Group 392">
              <circle
                id="Ellipse_58"
                data-name="Ellipse 58"
                className="cls-2"
                cx="24.639"
                cy="24.639"
                r="24.639"
                transform="translate(249 318)"
              />
              <path
                id="Path_425"
                data-name="Path 425"
                d="M273.639,368.278a25.639,25.639,0,1,1,25.639-25.639A25.667,25.667,0,0,1,273.639,368.278Zm0-49.278a23.639,23.639,0,1,0,23.639,23.639A23.665,23.665,0,0,0,273.639,319Z"
              />
            </g>
          </g>
          <g id="Group_402" data-name="Group 402">
            <g id="Group_395" data-name="Group 395">
              <g id="Group_394" data-name="Group 394">
                <path
                  id="Path_426"
                  data-name="Path 426"
                  d="M422.813,288.724c-.124.178-1.081-.2-2.678-1.04-.8-.411-1.747-.989-2.889-1.522-.559-.291-1.173-.57-1.825-.859-.643-.307-1.344-.584-2.076-.88a48.166,48.166,0,0,0-4.875-1.653,49.081,49.081,0,0,0-5.753-1.244,46.841,46.841,0,0,0-6.461-.525,43.2,43.2,0,0,0-6.928.445,44.906,44.906,0,0,0-12.8,3.89,44.153,44.153,0,0,0-5.156,2.845c-1.575.974-2.95,2.02-4.207,2.979l-1.74,1.439-1.508,1.344c-.918.867-1.708,1.625-2.334,2.267-.653.621-1.122,1.14-1.492,1.455s-.6.463-.679.4-.018-.319.188-.763a13.329,13.329,0,0,1,1.054-1.848,30.71,30.71,0,0,1,2-2.709c.422-.5.9-1.024,1.391-1.583.512-.543,1.073-1.1,1.663-1.684a42.644,42.644,0,0,1,4.191-3.467,40.372,40.372,0,0,1,5.321-3.3,41.029,41.029,0,0,1,6.384-2.724,43.013,43.013,0,0,1,7.268-1.725,41.617,41.617,0,0,1,7.454-.419,43.053,43.053,0,0,1,12.952,2.37,40.071,40.071,0,0,1,5.013,2.126c.74.379,1.442.742,2.079,1.136.647.376,1.248.742,1.787,1.122a27,27,0,0,1,2.669,2.03C422.232,287.806,422.938,288.546,422.813,288.724Z"
                />
              </g>
            </g>
            <g id="Group_397" data-name="Group 397">
              <g id="Group_396" data-name="Group 396">
                <path
                  id="Path_427"
                  data-name="Path 427"
                  d="M291.962,304.761c-.055.05-.242-.04-.546-.256s-.706-.573-1.256-1-1.193-.965-1.977-1.546-1.684-1.227-2.716-1.881-2.189-1.321-3.457-1.982a41.22,41.22,0,0,0-4.181-1.818,37.213,37.213,0,0,0-4.818-1.417,35,35,0,0,0-10.7-.739,37.148,37.148,0,0,0-4.969.739,41.426,41.426,0,0,0-4.394,1.223c-1.348.479-2.593.969-3.7,1.488s-2.1,1.021-2.95,1.493-1.578.9-2.171,1.263c-.6.342-1.042.654-1.376.821s-.521.246-.564.194.064-.224.311-.5a12.186,12.186,0,0,1,1.159-1.147,23.746,23.746,0,0,1,2.022-1.606,29.518,29.518,0,0,1,2.9-1.833,35.392,35.392,0,0,1,3.755-1.81,36.007,36.007,0,0,1,4.559-1.494,34.782,34.782,0,0,1,5.233-.919,33.774,33.774,0,0,1,11.364.775,34.81,34.81,0,0,1,5.062,1.618,36.371,36.371,0,0,1,4.317,2.1,34.729,34.729,0,0,1,3.477,2.3,29.451,29.451,0,0,1,2.623,2.212,23.037,23.037,0,0,1,1.785,1.868,11.207,11.207,0,0,1,.987,1.3C291.938,304.523,292.017,304.712,291.962,304.761Z"
                />
              </g>
            </g>
            <g id="Group_398" data-name="Group 398">
              <path
                id="Path_428"
                data-name="Path 428"
                d="M396.493,387.924c-24.359,0-44.177-20.131-44.177-44.874s19.818-44.875,44.177-44.875,44.177,20.131,44.177,44.875S420.853,387.924,396.493,387.924Zm0-86.749c-22.705,0-41.177,18.785-41.177,41.875s18.472,41.874,41.177,41.874S437.67,366.14,437.67,343.05,419.2,301.175,396.493,301.175Z"
              />
            </g>
            <g id="Group_399" data-name="Group 399">
              <path
                id="Path_429"
                data-name="Path 429"
                d="M265.018,391.563c-20.782,0-37.688-19.013-37.688-42.384s16.906-42.385,37.688-42.385S302.7,325.808,302.7,349.179,285.8,391.563,265.018,391.563Zm0-81.769c-19.127,0-34.688,17.668-34.688,39.385s15.561,39.384,34.688,39.384S299.7,370.9,299.7,349.179,284.145,309.794,265.018,309.794Z"
              />
            </g>
            <g id="Group_401" data-name="Group 401">
              <g id="Group_400" data-name="Group 400">
                <path
                  id="Path_430"
                  data-name="Path 430"
                  d="M455.79,374.418c-.021.285-1,.522-2.723.715-.431.047-.909.091-1.431.128l-1.695.185c-1.213.135-2.591.2-4.1.428l-2.374.284c-.824.1-1.675.264-2.558.393-1.77.235-3.635.645-5.6,1.02-.983.192-1.974.467-2.995.7l-1.545.363-1.557.444c-2.108.549-4.24,1.279-6.435,1.991-2.158.816-4.28,1.578-6.268,2.467l-1.494.623-1.435.68c-.942.457-1.889.86-2.777,1.324-1.77.935-3.484,1.78-5.014,2.7-.771.451-1.539.853-2.244,1.292l-2.03,1.264c-1.324.77-2.441,1.581-3.475,2.232s-1.911,1.238-2.631,1.719c-1.462.934-2.359,1.376-2.546,1.174s.357-1.026,1.5-2.38a24.46,24.46,0,0,1,2.225-2.325c.914-.857,1.942-1.862,3.191-2.829l1.945-1.547c.682-.531,1.434-1.024,2.2-1.562,1.509-1.1,3.226-2.109,5.025-3.192.9-.538,1.868-1.01,2.837-1.531l1.476-.773,1.545-.707c2.064-.988,4.28-1.824,6.549-2.681,2.306-.754,4.557-1.493,6.785-2.016l1.646-.42,1.635-.326c1.08-.2,2.13-.442,3.17-.588,2.081-.285,4.052-.576,5.917-.666.931-.057,1.826-.144,2.691-.158l2.486-.012c1.58-.032,3.011.111,4.261.205a22.813,22.813,0,0,1,3.192.427C454.871,373.81,455.811,374.133,455.79,374.418Z"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Group_404" data-name="Group 404">
          <ellipse
            id="Ellipse_59"
            data-name="Ellipse 59"
            className="cls-1"
            cx="13.23"
            cy="9.336"
            rx="13.23"
            ry="9.336"
            transform="matrix(0.9, -0.437, 0.437, 0.9, 383.996, 327.216)"
          />
        </g>
        <g id="Group_405" data-name="Group 405">
          <ellipse
            id="Ellipse_60"
            data-name="Ellipse 60"
            className="cls-1"
            cx="9.759"
            cy="6.886"
            rx="9.759"
            ry="6.886"
            transform="matrix(0.9, -0.437, 0.437, 0.9, 255.287, 331.967)"
          />
        </g>
      </g>
    </StyledSvg>
  );
};

Eyes.propTypes = {
  fill: PropTypes.string
};

export default React.memo(
  Eyes,
  (prevProps, nextProps) => prevProps.fill === nextProps.fill
);
